import React, { useState } from "react";
import SchoolMS_FAQs from "../../ServiceDetails/Faq/Faq"


const AccordionItem = ({ question, answer, isOpen, onClick }) => {
    return (
      <div className="accordion-item">
        <div className="accordion-header" id={question}>
          <button
            className={`accordion-button ${isOpen ? "" : "collapsed"}`}
            type="button"
            onClick={onClick}
            aria-expanded={isOpen}
            aria-controls={question}
          >
            <span className="title">{question}</span>
          </button>
        </div>
        <div
          id={question}
          className={`accordion-collapse collapse ${isOpen ? "show" : ""}`}
          aria-labelledby={question}
        >
          <div className="accordion-body">{answer}</div>
        </div>
      </div>
    );
  };

const SchoolMS_FAQ = () => {
    const [activeIndex, setActiveIndex] = useState(null);

  const items = [
    {
      question: "What is Harsafe Meet?",
      answer:
        "Harsafe Meet is a secure chat and video conferencing app designed for seamless communication and collaboration.",
    },
    {
      question: "Is Harsafe Meet secure?",
      answer:
        "Yes, Harsafe Meet uses end-to-end encryption to ensure your messages and calls remain private and secure.",
    },
    {
      question: "Can I host video meetings with Harsafe Meet?",
      answer:
        "Absolutely! You can host HD video meetings for personal or professional purposes with options for screen sharing and recording.",
    },
    {
      question: "Does Harsafe Meet support group chats?",
      answer:
        "Yes, you can create group chats for teams, friends, or family, enabling effective communication in one place.",
    },
    {
      question: "Can I access Harsafe Meet on multiple devices?",
      answer:
        "Yes, Harsafe Meet works seamlessly across smartphones, tablets, and desktops, ensuring flexibility and convenience.",
    },
  ];

  const handleClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };
    

  return (
    <div className="section harsafe-choose-us-section-02 section-padding">
      <div className="container">
        {/* <!-- Pricing Wrap Start --> */}
        <div className="pricing-wrap">
          <div className="section-title text-center">
            <h3 className="sub-title">FAQ</h3>
            <h2 className="title">FAQ's</h2>
          </div>
          <div className="pricing-content-wrap">
            <div className="col-lg-8 col-md-12 m-auto">

              <div className="choose-us-right">
                <div className="faq-accordion">
                  <div className="accordion" id="accordionExample">
                    {items.map((item, index) => (
                      <AccordionItem
                        key={index}
                        question={item.question}
                        answer={item.answer}
                        isOpen={activeIndex === index}
                        onClick={() => handleClick(index)}
                      />
                    ))}
                  </div>
                </div>
              </div>
              

            </div>
          </div>
        </div>
        {/* <!-- Pricing Wrap End --> */}
      </div>
    </div>
  )
}

export default SchoolMS_FAQ